export default __webpack_public_path__ + "static/media/xls_ico.3a4a4d52.svg";